
import CustomerDetailsForm from "./ContactTypeForms/CustomerDetailsForm";
import SuppliersDetailForm from "./ContactTypeForms/SuppliersDetailForm";
import TransporterDetailForm from "./ContactTypeForms/TransporterDetailForm";
import { GeneralDetailsFormContainer } from "./GeneralDetailsFormContainer";
import {GeneralDetailsFormComponentSchema} from "./FormComponentSchema";


const GeneralDetailsFormComponent: React.FC<GeneralDetailsFormComponentSchema> = ({
  newContactCreatedDetail,
  register,
  errors,
  control,
  setValue,
  customerTaxType,
  // accountGrpDefaultValue,
  handleBlurFirstName,
  handleBlurLastName,
  handleBlurCompanyName,
  handleBlurContactNo,
  handleBlurCreditAmount,
  handleBlurDebitAmount,
}) => {
 
  const accountGroupArr = newContactCreatedDetail?.AccountGroupData?.map(
    (acc) => ({
      ...acc,
      value: acc.accountGroupId,
      label: `${acc.accountGroupName} (${acc.parentGroup})`,
    })
  ) ?? [];

  const paymentTermArr = newContactCreatedDetail?.paymentTermList?.map(
    (term) => ({
      ...term,
      value: term.paymentTermId,
      label: term.paymentTermName,
    })
  ) ?? [];
  const customerCatArr = newContactCreatedDetail?.customerCategoryList?.map(
    (cust) => ({
      ...cust,
      value: cust.customerCategoryId,
      label: cust.customerCategoryName,
    })
  ) ?? [];

  const membershipArr = newContactCreatedDetail?.membershiplist?.map((mem) => ({
    ...mem,
    value: mem.membershipId,
    label: mem.membershipName,
  })) ?? [];
 
  return (
    <GeneralDetailsFormContainer>
      {(newContactCreatedDetail?.typeOfContact === "customers" ||
        newContactCreatedDetail?.type === "customers") && (
        <CustomerDetailsForm
          accountGroupArr={accountGroupArr}
          membershipArr={membershipArr}
          customerTaxType={customerTaxType}
          paymentTermArr={paymentTermArr}
          customerCatArr={customerCatArr}
          // accountGrpDefaultValue={accountGrpDefaultValue}
          register={register}
          errors={errors}
          control={control}
          setValue={setValue}
          newContactCreatedDetail={newContactCreatedDetail}
          handleBlurFirstName={handleBlurFirstName}
          handleBlurLastName={handleBlurLastName}
          handleBlurCompanyName={handleBlurCompanyName}
          handleBlurContactNo={handleBlurContactNo}
          handleBlurCreditAmount={handleBlurCreditAmount}
          handleBlurDebitAmount={handleBlurDebitAmount}
        />
      )}

      {(newContactCreatedDetail?.typeOfContact === "suppliers" ||
        newContactCreatedDetail?.type === "suppliers") && (
        <SuppliersDetailForm
          accountGroupArr={accountGroupArr}
          membershipArr={membershipArr}
          paymentTermArr={paymentTermArr}
          customerCatArr={customerCatArr}
          newContactCreatedDetail={newContactCreatedDetail}
          register={register}
          errors={errors}
          control={control}
          setValue={setValue}
          handleBlurFirstName={handleBlurFirstName}
          handleBlurLastName={handleBlurLastName}
          handleBlurCompanyName={handleBlurCompanyName}
          handleBlurContactNo={handleBlurContactNo}
          handleBlurCreditAmount={handleBlurCreditAmount}
          handleBlurDebitAmount={handleBlurDebitAmount}
        />
      )}

      {(newContactCreatedDetail?.typeOfContact === "transport" ||
        newContactCreatedDetail?.type === "transport") && (
        <TransporterDetailForm
          accountGroupArr={accountGroupArr}
          membershipArr={membershipArr}
          paymentTermArr={paymentTermArr}
          customerCatArr={customerCatArr}
          // accountGrpDefaultValue={accountGrpDefaultValue}
          newContactCreatedDetail={newContactCreatedDetail}
          register={register}
          errors={errors}
          control={control}
          setValue={setValue}
          handleBlurFirstName={handleBlurFirstName}
          handleBlurLastName={handleBlurLastName}
          handleBlurCompanyName={handleBlurCompanyName}
          handleBlurCreditAmount={handleBlurCreditAmount}
          handleBlurDebitAmount={handleBlurDebitAmount}
        />
      )}
    </GeneralDetailsFormContainer>
  );
};

export default GeneralDetailsFormComponent;
